<div class="form-group row">
  <label class="default-label col-12 col-form-label form-label {{ hiddenFieldLabelClass }}">
    {{ model.description }}
  </label>
  <div class="col-12 sm-flex sm-flex-col sm-space-y-2">
    <div *ngIf="model.isHiddenInFormPDFExports" class="sm-text-secondary-text" data-test="hidden-in-form-label">
      <small i18n>(Hidden in Form PDF exports)</small>
    </div>
    <span class="sm-text-secondary-text {{ hiddenFieldLabelClass }}" data-test="scan-signon-entries">
      {{ model.entries?.length || 0 }} <span i18n>{{ model.entries?.length === 1 ? 'row' : 'rows' }}</span>
    </span>
    <table class="table table-bordered">
      <thead>
        <th></th>
        <th i18n>Name</th>
        <th i18n>Company</th>
        <th i18n>Signature</th>
        <th i18n>Date</th>
        <th i18n>Time</th>
        <th i18n>Location</th>
      </thead>
      <tbody>
        <tr *ngIf="!model.entries || !model.entries.length">
          <td colspan="7">
            <div class="sm-mt-4 sm-flex sm-justify-center">
              <img
                src="./assets/images/user/sitemate-users/sitemate-id-mockup.svg"
                alt="sitemate-id-mockup"
                class="sitemate-id-mockup sm-w-legacy-22.4"
              />
            </div>
            <div class="sm-m-4" i18n>
              Users of the
              <img
                title="Sitemate"
                src="assets/icons/multi-colored-icons/sitemate-square.svg"
                alt="sitemate-logo"
                class="sm-inline-block sm-align-middle"
              />
              <a
                id="sitemate-app"
                class="sm-underline"
                href="https://intercom.help/dashpivot/en/articles/5401392-sitemate-app-overview"
                target="_blank"
              >
                Sitemate App</a
              >
              can be scanned on by a
              <img
                src="assets/icons/multi-colored-icons/dashpivot-square.svg"
                alt="dashpivot-logo"
                class="sm-inline-block sm-align-middle"
              />
              <a
                id="dashpivot-app"
                class="sm-underline"
                href="https://intercom.help/dashpivot/en/articles/2563239-dashpivot-app-overview"
                target="_blank"
              >
                Dashpivot App</a
              >
              user to sign on.
            </div>

            <div class="text-center sm-mb-4">
              <a
                id="learn-more"
                href="https://intercom.help/dashpivot/en/articles/3901878-setting-up-a-contactless-sign-on-process"
                target="_blank"
                class="px-2 py-1 rounded btn btn-sm cc-btn-subtle-gray help-text"
              >
                <i class="mr-1 cc-icon cc-icon-question" aria-hidden="true"></i><span i18n>Learn more</span>
              </a>
            </div>
          </td>
        </tr>
        <tr *ngFor="let entry of model.entries; let i = index">
          <td>
            <div *ngIf="canDeleteRows">
              <button
                class="delete-entry btn-link"
                (click)="onDeleteEntry(entry, i)"
                title="Delete"
                type="button"
              >
                <i class="fa fa-times sm-text-default-red" aria-hidden="true"></i>
              </button>
            </div>
            <div class="mt-2">
              <i
                class="cc-icon cc-icon-warning"
                *ngIf="entry.error"
                [ngbPopover]="entry.error"
                popoverClass="no-max-width"
                triggers="hover"
                aria-hidden="true"
              ></i>
            </div>
          </td>
          <td><cc-signon-table-user [user]="entry.user"></cc-signon-table-user></td>
          <td>{{ entry.user.companyName }}</td>
          <td>
            <img
              (contextmenu)="limitPointerEvents()"
              (dragstart)="limitPointerEvents()"
              class="signature"
              [src]="getSignatureImage(entry.user.signatureUrl)"
              alt="Signature of {{ entry.user.firstName }} {{ entry.user.lastName }}"
            />
          </td>
          <td>{{ entry.date | date: 'mediumDate' }}</td>
          <td>{{ entry.date | date: 'shortTime' }}</td>
          <td><cc-signon-table-location [point]="entry.location"></cc-signon-table-location></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
